<template>
  <div class="buy-credits">
    <div class="buy-credits__center">
      <div class="buy-credits__selectorwrap">
        <div>{{ $t('buyCredits.title') }}</div>
        <vue-slider-wrap :credits="credits" @creditsData="getCreditsData"></vue-slider-wrap>
        <div class="buy-credits__more">
          {{
            $t('buyCredits.bigPurchases', {
              credits: formatCredits(creditsData.endCreditsSlider)
            })
          }}
          <a href="mailto:info@game-learn.com">{{ $t('buyCredits.contact') }}</a>
        </div>
      </div>

      <div class="buy-credits__colright">
        <div class="buy-credits__biginput">
          <form>
            <input
              id="account.credit.slider"
              v-model="credits"
              class="credits"
              :min="creditsData.startCreditsSlider"
              :max="creditsData.endCreditsSlider"
              type="number"
              @input="checkInputValue"
            />
          </form>
          <span>{{ $t('buyCredits.credits') }}</span>
        </div>
        <div class="buy-credits__cta">
          <div class="buy-credits__total">
            {{ $n(subtotal, 'currency', currency) }}
          </div>
          <div class="u-font-x-small">
            {{ $n(pricePerCredit, 'currency', currency) }} /
            {{ $t('buyCredits.credit').toLowerCase() }}
          </div>
          <gl-button
            id="account.credit.btn-credit"
            color-primary
            class="buy-credits__submit"
            :type="'submit'"
            :text="$t('actions.buy')"
            :disabled="!validNumber"
            @onClick.prevent="goToPayment"
          ></gl-button>
        </div>
      </div>
    </div>
    <div class="buy-credits__cancelwrap">
      <gl-button
        id="account.credit.btn-cancel"
        color-secondary
        :type="'submit'"
        :text="$t('actions.cancel')"
        @onClick.prevent="goBack"
      ></gl-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSliderWrap from './VueSliderWrap.vue';

export default {
  name: 'CreditsSlider',
  components: {
    VueSliderWrap
  },
  data() {
    return {
      priceInput: null,
      credits: null,
      subtotal: null,
      pricePerCredit: null,
      currency: 'USD'
    };
  },
  computed: {
    ...mapState({
      creditsData: (state) => state.payments.creditsData,
      isEUCountry: (state) => state.payments.isEUCountry
    }),
    validNumber() {
      return this.credits >= this.creditsData.startCreditsSlider;
    }
  },
  async created() {
    this.credits = this.creditsData.creditPrice;
    this.currency = this.isEUCountry ? 'EUR' : 'USD';
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'account' });
    },
    goToPayment() {
      this.$emit('showSlider', false);
      const creditsData = {
        credits: this.credits,
        subtotal: this.subtotal,
        pricePerCredit: this.pricePerCredit
      };
      this.$emit('purchaseData', creditsData);
    },
    formatCredits(value) {
      const val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    getCreditsData(credits) {
      this.credits = credits;
      this.getCreditPrice(credits);
    },
    checkInputValue() {
      let credits = Math.round(this.credits);
      this.credits > this.creditsData.endCreditsSlider
        ? (credits = this.creditsData.endCreditsSlider)
        : null;
      this.credits = credits;
      this.getCreditPrice(credits);
    },
    getCreditPrice(credits) {
      let discount;
      let creditPrice = this.isEUCountry
        ? this.creditsData.creditPriceEUR
        : this.creditsData.creditPriceUSD;

      switch (true) {
        case credits >= this.creditsData.sectionsSlider01 &&
          credits < this.creditsData.sectionsSlider02:
          discount = (this.creditsData.firstDiscount * creditPrice) / 100;
          break;
        case credits >= this.creditsData.sectionsSlider02 &&
          credits < this.creditsData.sectionsSlider03:
          discount = (this.creditsData.secondDiscount * creditPrice) / 100;
          break;
        case credits >= this.creditsData.sectionsSlider03 &&
          credits < this.creditsData.sectionsSlider04:
          discount = (this.creditsData.thirdDiscount * creditPrice) / 100;
          break;
        case credits >= this.creditsData.sectionsSlider04:
          discount = (this.creditsData.quarterDiscount * creditPrice) / 100;
          break;
        default:
          discount = 0;
      }

      this.pricePerCredit = creditPrice - discount;
      this.subtotal = credits * this.pricePerCredit;
    }
  }
};
</script>
